import React from 'react'

const AddHoldAtTerminalComponentLoadable = React.lazy(() => import('./AddHoldAtTerminalComponent'));
const HoldAtTerminalComponentLoadable = React.lazy(() => import('./HoldAtTerminalComponent'));
export {
    AddHoldAtTerminalComponentLoadable,
    HoldAtTerminalComponentLoadable
}